'use strict';
var ResourcesBySupplementsController = /** @class */ (function () {
    /*@ngInject*/
    function ResourcesBySupplementsController($scope, ResourcesBySupplementsService, $sce, EducationSubNavService) {
        this.headerContent = "As a valued customer, we are proud to offer you access to a suite of tools from Aisle 7. Explore below to read summarized research by active compound, nutrient, and botanical medicine.";
        $scope.$ctrl.value.selectedpageindex = 1;
        $scope.$ctrl.value.level = '2';
        this.eduSubNavService = EducationSubNavService;
        this.eduSubNavService.level = '2';
        this.ResourcesBySupplementsService = ResourcesBySupplementsService;
        $scope.botanicalMedicinesFrameUrl = $sce.trustAsResourceUrl('/api/education/clinical-resources-subpage?page=botanical-medicines');
        $scope.nutritionalSupplementsFrameUrl = $sce.trustAsResourceUrl('/api/education/clinical-resources-subpage?page=nutritional-supplements');
    }
    return ResourcesBySupplementsController;
}());
export default ResourcesBySupplementsController;
//# sourceMappingURL=resources-by-supplements.controller.js.map